import api from "./api";

export const getAgentProgression = async (agentId) => {
    try {
        const response = await api.get(
            `/agent-progression-management/agent-progressions/${agentId}`
        );

        if (response.status === 200 && response.data?.success) {
            return {
                success: true,
                data: response.data.data,
            };
        }

        return {
            success: false,
            error:
                response.data?.message ||
                "Failed to retrieve agent progression.",
        };
    } catch (error) {
        return {
            success: false,
            error:
                error.response?.data?.detail ||
                error.response?.data?.message ||
                error.message ||
                "Failed to retrieve agent progression.",
        };
    }
};

export const fetchProgressionConfigurations =
    async () => {

        try {

            const response =
                await api.get(
                    "/agent-progression-config/agent-progression/configurations"
                );


            if (
                response.status === 200 &&
                response.data?.success
            ) {

                return {
                    success: true,
                    data:
                        response.data.data || [],
                };

            }


            return {
                success: false,
                error:
                    response.data?.message ||
                    "Unexpected response from server",
            };

        } catch (error) {

            console.error(
                "Error fetching progression configurations:",
                error.message || error
            );


            return {
                success: false,
                error:
                    error.response?.data?.detail ||
                    error.response?.data?.message ||
                    error.message ||
                    "Failed to fetch progression configurations",
            };

        }
    };



export const createProgressionConfiguration =
    async (payload) => {

        try {

            const response =
                await api.post(
                    "/agent-progression-config/agent-progression/configurations",
                    payload
                );


            if (
                (
                    response.status === 200 ||
                    response.status === 201
                ) &&
                response.data?.success
            ) {

                return {
                    success: true,
                    data:
                        response.data.data,
                };

            }


            return {
                success: false,
                error:
                    response.data?.message ||
                    "Unexpected response from server",
            };

        } catch (error) {

            console.error(
                "Error creating progression configuration:",
                error.message || error
            );


            return {
                success: false,
                error:
                    error.response?.data?.detail ||
                    error.response?.data?.message ||
                    error.message ||
                    "Failed to create progression configuration",
            };

        }
    };



export const updateProgressionConfiguration =
    async (
        configurationId,
        payload
    ) => {

        try {

            const response =
                await api.put(
                    `/agent-progression-config/agent-progression/configurations/${configurationId}`,
                    payload
                );


            if (
                response.status === 200 &&
                response.data?.success
            ) {

                return {
                    success: true,
                    data:
                        response.data.data,
                };

            }


            return {
                success: false,
                error:
                    response.data?.message ||
                    "Unexpected response from server",
            };

        } catch (error) {

            console.error(
                "Error updating progression configuration:",
                error.message || error
            );


            return {
                success: false,
                error:
                    error.response?.data?.detail ||
                    error.response?.data?.message ||
                    error.message ||
                    "Failed to update progression configuration",
            };

        }
    };


export const deleteProgressionConfiguration =
    async (
        configurationId
    ) => {

        try {

            const response =
                await api.delete(
                    `/agent-progression-config/agent-progression/configurations/${configurationId}`
                );


            if (
                response.status === 200 &&
                response.data?.success
            ) {

                return {
                    success: true,
                    data:
                        response.data.data,

                    message:
                        response.data.message ||
                        "Progression configuration deleted successfully",
                };

            }


            return {
                success: false,
                error:
                    response.data?.message ||
                    "Unexpected response from server",
            };

        } catch (error) {

            console.error(
                "Error deleting progression configuration:",
                error.message || error
            );


            return {
                success: false,
                error:
                    error.response?.data?.detail ||
                    error.response?.data?.message ||
                    error.message ||
                    "Failed to delete progression configuration",
            };

        }
    };